require("bootstrap");
import AutoNumeric from "autonumeric";
import { managePaymentOptions, validateAmountToDonate } from "../../utils";
import "../../../../stylesheets/payment_methods/recurring-selector";

const DELAYED_SUBSCRIPTION_FIELD =
  "#donator_donation_transactions_attributes_0_delayed_subscription_amount";
const DELAYED_AMOUNT_FORM = "#delayed-subscription-form #amount-form";
const DELAYED_SUBSCRIPTION_MODAL = "#delayed-subscription-form";

let isFirstDelayedAmountInput = true;

function validateDelayedSubscriptionAmount(form = DELAYED_SUBSCRIPTION_MODAL) {
  return validateAmountToDonate(
    "subscription",
    "clp",
    DELAYED_SUBSCRIPTION_FIELD,
    form,
    DELAYED_AMOUNT_FORM
  );
}

function clearDelayedSubscriptionValidation() {
  $(DELAYED_SUBSCRIPTION_FIELD).removeClass("is-invalid");
  $(`${DELAYED_AMOUNT_FORM} div.invalid-feedback`).hide();
  isFirstDelayedAmountInput = true;
  paintModalSummary(0);
}

function getDelayedSubscriptionAmountValue() {
  const el = document.querySelector(DELAYED_SUBSCRIPTION_FIELD);
  if (!el) return 0;
  const an = AutoNumeric.getAutoNumericElement(el);
  if (an) return parseInt(an.getNumericString(), 10) || 0;
  return parseInt(el.value.replace(/\./g, ""), 10) || 0;
}

function formatClpForSummary(n) {
  const v = Math.floor(Number(n)) || 0;
  if (v === 0) return "$0";
  return "$" + v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function paintSubscriptionSummary(amount, $roots) {
  const n = Math.floor(Number(amount)) || 0;
  const text = formatClpForSummary(n);
  $roots.find(".js-summary-delayed-subscription-amount").text(text);
  $roots
    .find("[data-purchase-summary-subscription]")
    .toggleClass("d-none", n === 0);
}

function paintOuterSummary(amount) {
  const $roots = $(".purchase-summary").filter(function () {
    return $(this).closest("#delayed-subscription-form").length === 0;
  });
  paintSubscriptionSummary(amount, $roots);
}

function paintModalSummary(amount) {
  const $roots = $(`${DELAYED_SUBSCRIPTION_MODAL} .purchase-summary`);
  if (!$roots.length) return;
  paintSubscriptionSummary(amount, $roots);
}

function resetDelayedRecurringToOnce() {
  const delayedEl = document.querySelector(DELAYED_SUBSCRIPTION_FIELD);
  if (!delayedEl) return;
  const an = AutoNumeric.getAutoNumericElement(delayedEl);
  if (an) an.clear();
  else delayedEl.value = "";
  clearDelayedSubscriptionValidation();
  const ct = $("#currency-type").val() || window.currency_type || "clp";
  window.currency_type = ct;
  managePaymentOptions(ct, "once");
  paintOuterSummary(0);
}

$(document).ready(function () {
  if (window.currency_type == "clp") {
    $("#recurring-radio-container").show();
  }
  $(".currency-selection label").click(({ target }) => {
    const currency = target.getAttribute("data-currency");
    window.currency_type = currency;
    if (currency == "clp") {
      $("#recurring-radio-container").show();
    } else {
      $("#recurring-radio-container").hide();
      const $single = $('[name="recurring_radio_with_modal"]#single-donation');
      if ($single.length) {
        $single.prop("checked", true).trigger("change");
      } else {
        resetDelayedRecurringToOnce();
      }
      $("#delayed-subscription-form").modal("hide");
    }
  });
  $('[name="recurring_radio_with_modal"]').change(function () {
    if (this.value == "subscription") {
      $("#delayed-subscription-form").modal("show");
    } else {
      resetDelayedRecurringToOnce();
    }
  });

  $(DELAYED_SUBSCRIPTION_MODAL).on("shown.bs.modal", function () {
    paintModalSummary(getDelayedSubscriptionAmountValue());
  });

  paintOuterSummary(0);

  $("#delayed-subscription-form .close").on("click", function () {
    $('[name="recurring_radio_with_modal"]#single-donation')[0].checked = true;
    clearDelayedSubscriptionValidation();
  });

  if ($(DELAYED_SUBSCRIPTION_FIELD).length) {
    $(DELAYED_SUBSCRIPTION_FIELD).on("input valueChanged", () => {
      paintModalSummary(getDelayedSubscriptionAmountValue());
      if (isFirstDelayedAmountInput) {
        isFirstDelayedAmountInput = false;
        return;
      }
      validateDelayedSubscriptionAmount();
    });
  }

  $("#confirm-delayed-subscription-button").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    const validation = validateDelayedSubscriptionAmount("#new_donator");
    if (validation.valid) {
      const selector = ".payment-selection .custom-control";
      $(`${selector}`).addClass("hidden-input");
      $(`${selector}.payment-clp.payment-delayed-subscription`).removeClass(
        "hidden-input"
      );
      $(DELAYED_SUBSCRIPTION_FIELD)[0].value = validation.amount;
      paintOuterSummary(validation.amount);
      $("#delayed-subscription-form").modal("hide");
    }
  });
});
